import { getById } from "@insite/client-framework/Store/Data/DataState";
import { GetPaymentHistoryApiParameter } from "@store/Services/PaymentHistoryService";
import { getDataView } from "@store/Store/Data/DataState";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { createContext } from "react";

export function getPaymentHistoryState(state: StoreApplicationState, paymentHistoryNumber: string | undefined) {
    return getById(
        state.store.data.payments,
        paymentHistoryNumber,
        id => state.store.data.payments.idByPaymentNumber[id],
    );
}

export function getPaymentHistoryDataView(
    state: StoreApplicationState,
    getPaymentHistoryParameter: GetPaymentHistoryApiParameter,
) {
    return getDataView(state.store.data.payments, getPaymentHistoryParameter);
}

export const PaymentHistoryDataViewContext = createContext<ReturnType<typeof getPaymentHistoryDataView>>({
    value: undefined,
    isLoading: false,
});

export const PaymentHistoryStateContext = createContext<ReturnType<typeof getPaymentHistoryState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
